import { useState, useEffect, useRef } from 'react';
import { WifiOff, Wifi } from 'lucide-react';

export function NetworkStatusBanner() {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine);
  const [showRestored, setShowRestored] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    function handleOnline() {
      setIsOnline(true);
      setShowRestored(true);
      timerRef.current = setTimeout(() => setShowRestored(false), 4000);
    }
    function handleOffline() {
      setIsOnline(false);
      setShowRestored(false);
      clearTimeout(timerRef.current);
    }

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearTimeout(timerRef.current);
    };
  }, []);

  if (isOnline && !showRestored) return null;

  return (
    <div
      role="status"
      aria-live="assertive"
      aria-atomic="true"
      className={`network-banner ${isOnline ? 'network-banner--online' : 'network-banner--offline'}`}
    >
      {isOnline ? (
        <>
          <Wifi size={14} aria-hidden="true" />
          <span>Back online</span>
        </>
      ) : (
        <>
          <WifiOff size={14} aria-hidden="true" />
          <span>You're offline — changes won't save until you reconnect</span>
        </>
      )}
    </div>
  );
}
